var $ = require('../internals/export');
var $parseFloat = require('../internals/number-parse-float');

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.parse-float.js
// module id = 365
// module chunks = 0